'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../tslib.es6-130a177d.js');
var React = require('react');
var ReactDOM = require('react-dom');
var styled = require('styled-components');
var useOutsideClick = require('../useOutsideClick-531afbb5.js');
var useOnEscapePress = require('../useOnEscapePress-9ee80763.js');
var useForceUpdateRef = require('../useForceUpdateRef-6d1ca28f.js');
require('../useOnKeyboardPress-d580d97f.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var StyledBackdropWrapper = styled__default['default'].div.withConfig({ displayName: "ww-uikit_StyledBackdropWrapper_locmlpvr", componentId: "sc-5ztv2x" })(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: auto;\n    background: ", ";\n    z-index: ", ";\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n"], ["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: auto;\n    background: ", ";\n    z-index: ", ";\n    position: fixed;\n    right: 0;\n    top: 0;\n    bottom: 0;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.skeleton02;
}, function (_a) {
    var theme = _a.theme;
    return theme.zIndexPopUpOverlay;
});
var OverlayContainerContext = React__default['default'].createContext({ container: undefined });
var OverlayContainerProvider = function (_a) {
    var container = _a.container, children = _a.children;
    return React__default['default'].createElement(OverlayContainerContext.Provider, { value: { container: container } }, children);
};
function useOverlayContainer() {
    var overlayContainer = React__default['default'].useContext(OverlayContainerContext).container;
    var _a = useForceUpdateRef.useForceUpdateRef(), element = _a[0], setElement = _a[1];
    React.useEffect(function () {
        var newElement = document.createElement('div');
        (overlayContainer || document.body).appendChild(newElement);
        setElement(newElement);
        return function () {
            if (element) {
                (overlayContainer || document.body).removeChild(element);
            }
        };
    }, [overlayContainer]);
    return element;
}
var Backdrop = function (_a) {
    var className = _a.className, contentRef = _a.contentRef, children = _a.children, isOpen = _a.isOpen, onClose = _a.onClose, _b = _a.dismissable, dismissable = _b === void 0 ? true : _b, dataTestId = _a["data-testid"];
    var overlayContainer = useOverlayContainer();
    useOnEscapePress.useOnEscapePress(onClose, !!(isOpen && dismissable));
    useOutsideClick.useOutsideClick(onClose, {
        ref: contentRef,
        isEnabled: isOpen && dismissable,
    });
    if (!isOpen || !overlayContainer) {
        return null;
    }
    return ReactDOM.createPortal(React__default['default'].createElement(StyledBackdropWrapper, { "data-testid": dataTestId, className: className }, children), overlayContainer);
};
var templateObject_1;

exports.OverlayContainerProvider = OverlayContainerProvider;
exports.default = Backdrop;
//# sourceMappingURL=index.js.map
